
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.75 18.75a.75.75 0 01.102 1.493l-.102.007H10.5V22a.75.75 0 01-1.493.102L9 22v-1.75H4.5V22a.75.75 0 01-1.493.102L3 22v-1.75H1.75a.75.75 0 01-.102-1.493l.102-.007h10zm3.3-17.5c4.677 0 7.95 3.265 7.95 8.118 0 4.099-3.18 6.749-7.499 7.282L15.5 22a.75.75 0 01-1.493.102L14 22v-5.252l-.15.002c-4.485 0-8.207-3.145-8.346-7.109l-.004-.23c0-4.729 4.496-8.161 9.55-8.161zm0 1.5C10.75 2.75 7 5.612 7 9.412c0 3.19 3.063 5.838 6.85 5.838H14v-1.111l-2.609-2.609a.75.75 0 01.977-1.133l.084.073L14 12.018V8.5a.75.75 0 011.493-.102l.007.102v3.518l1.548-1.548.084-.073a.75.75 0 01.977 1.133L15.5 14.138v1c3.453-.483 5.881-2.508 5.996-5.544l.004-.226c0-4.024-2.6-6.618-6.45-6.618z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    